export const ADD_TO_WISH = 'ADD_TO_WISH';
export const REMOVE_FROM_WISH = 'REMOVE_FROM_WISH';
export const CLEAR_WISH = 'CLEAR_WISH';
